<template>
  <div>
    <div class="d-flex">
      <div class="mr-auto">
        <button class="btn btn-secondary" @click="refresh">
          <i class="fas fa-sync-alt fa-fw"></i>
        </button>
      </div>
      <div class="align-self-end">
        <input-debounced
            v-model="search"
            :clearable="true"
            :autofocus="true"
            placeholder="Search"
            class="search-bar w-300 mb-2"
        ></input-debounced>
      </div>
    </div>
    <base-table
        :base-url="urlWithFilters"
        ref="baseTable"
        @load-success="onLoadSuccess"
        @refresh="onRefresh"
        :current-page="currentPage"
        v-loading="isRefreshing"
        element-loading-spinner="el-icon-loading"
    >
      <template v-slot>
        <el-table
            :data="items"
            stripe
            class="w-100"
        >
          <el-table-column
              prop="model.id"
              label="Id"
              width="50"
          ></el-table-column>
          <el-table-column
            prop="model.from"
            label="From"
            min-width="120"
          >
          </el-table-column>
          <el-table-column
            prop="model.email_address.address"
            label="To"
            min-width="120"
          >
          </el-table-column>
          <el-table-column
            label="Subject"
            min-width="120"
            v-slot="{row: {model}}"
          >
            <subject-column :model="model"></subject-column>
          </el-table-column>
          <el-table-column
            label="Body"
            min-width="120"
            v-slot="{row}"
          >
            <body-column :row="row"></body-column>
          </el-table-column>
          <el-table-column
            label="Approved by"
            min-width="100"
            v-slot="{row: {model}}"
          >
            <user-column :model="model"></user-column>
          </el-table-column>
          <el-table-column
            prop="model.created_at"
            label="Send At"
            min-width="100"
            :formatter="formatDate"
          ></el-table-column>
          <el-table-column
            prop="model.updated_at"
            label="Updated At"
            min-width="100"
            :formatter="formatDate"
          ></el-table-column>
          <el-table-column label="Actions" v-slot="{row}">
            <actions-column
              :row="row"
              @delete="onDelete"
              @approve="onApprove"
            ></actions-column>
          </el-table-column>
        </el-table>
      </template>
    </base-table>
    <el-pagination
        layout="prev, pager, next"
        :total="total"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        class="text-right"
    ></el-pagination>
  </div>
</template>

<script>
import BaseTable from '../../../components/email-quarantine/table';

export default {
  extends: BaseTable,

  props: {
    canCreate: Boolean,
    createUrl: String,
  },

  created() {
    eventBus.$on('refresh-email-quarantine-table', this.refresh);
  },

  beforeDestroy() {
    eventBus.$off('refresh-email-quarantine-table', this.refresh);
  }
}
</script>
